import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/ui/button';
import type { ImportQueueController } from '../types/import-queue-controller';
import { buildImportTree } from '../utils/build-import-tree';
import { ImportQueueListControls } from './import-queue-list-controls';
import { ImportQueueTree } from './import-queue-tree';
interface ImportQueueSectionProps {
  controller: ImportQueueController;
  showHeader: boolean;
  showEmptyState?: boolean;
  /** When false, list controls render in the rail footer instead. */
  showListControlsInSection?: boolean;
}
export function ImportQueueSection(t0) {
  const $ = _c(37);
  const {
    controller,
    showHeader,
    showEmptyState: t1,
    showListControlsInSection: t2
  } = t0;
  const showEmptyState = t1 === undefined ? false : t1;
  const showListControlsInSection = t2 === undefined ? false : t2;
  const showListControls = showListControlsInSection && (Boolean(controller.listPreferences) || Boolean(controller.listActions));
  if (controller.items.length === 0) {
    if (!showEmptyState) {
      return null;
    }
    let t3;
    if ($[0] !== controller.subtitle || $[1] !== controller.title || $[2] !== showHeader) {
      t3 = showHeader ? <div className="pb-2"><p className="text-foreground text-xs leading-tight font-semibold tracking-wide uppercase">{controller.title}</p><p className="text-muted-foreground mt-0.5 text-xs leading-snug">{controller.subtitle}</p></div> : null;
      $[0] = controller.subtitle;
      $[1] = controller.title;
      $[2] = showHeader;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== controller || $[5] !== showListControls) {
      t4 = showListControls ? <div className="pb-3"><ImportQueueListControls controller={controller} /></div> : null;
      $[4] = controller;
      $[5] = showListControls;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <p className="text-muted-foreground text-sm">No recent uploads</p>;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== t3 || $[9] !== t4) {
      t6 = <li className="px-3 py-4">{t3}{t4}{t5}</li>;
      $[8] = t3;
      $[9] = t4;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  let t3;
  if ($[11] !== controller.items) {
    t3 = buildImportTree(controller.items);
    $[11] = controller.items;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const tree = t3;
  let t4;
  if ($[13] !== controller.items) {
    t4 = controller.items.filter(_temp);
    $[13] = controller.items;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const failedCount = t4.length;
  const canRetryAll = Boolean(controller.retryAllFailed) && failedCount > 1;
  let t5;
  if ($[15] !== controller.subtitle || $[16] !== controller.title || $[17] !== showHeader) {
    t5 = showHeader ? <div className="px-3 pt-2 pb-1"><p className="text-foreground text-xs leading-tight font-semibold tracking-wide uppercase">{controller.title}</p><p className="text-muted-foreground mt-0.5 text-xs leading-snug">{controller.subtitle}</p></div> : null;
    $[15] = controller.subtitle;
    $[16] = controller.title;
    $[17] = showHeader;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== controller || $[20] !== showListControls) {
    t6 = showListControls ? <div className="px-3 pb-2"><ImportQueueListControls controller={controller} /></div> : null;
    $[19] = controller;
    $[20] = showListControls;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== canRetryAll || $[23] !== controller.retryAllFailed || $[24] !== failedCount) {
    t7 = canRetryAll ? <div className="px-3 pb-1"><Button type="button" variant="secondary" size="sm" className="h-8 w-full text-xs" onClick={controller.retryAllFailed}>{`Retry all failed (${failedCount})`}</Button></div> : null;
    $[22] = canRetryAll;
    $[23] = controller.retryAllFailed;
    $[24] = failedCount;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== controller.activeNavigationId || $[27] !== controller.onItemClick || $[28] !== controller.retryItem || $[29] !== controller.statusLabelOverride || $[30] !== tree) {
    t8 = <ul><ImportQueueTree nodes={tree} activeNavigationId={controller.activeNavigationId} statusLabelOverride={controller.statusLabelOverride} onItemClick={controller.onItemClick} onRetry={controller.retryItem} data-sentry-element="ImportQueueTree" data-sentry-source-file="import-queue-section.tsx" /></ul>;
    $[26] = controller.activeNavigationId;
    $[27] = controller.onItemClick;
    $[28] = controller.retryItem;
    $[29] = controller.statusLabelOverride;
    $[30] = tree;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== t5 || $[33] !== t6 || $[34] !== t7 || $[35] !== t8) {
    t9 = <li data-sentry-component="ImportQueueSection" data-sentry-source-file="import-queue-section.tsx">{t5}{t6}{t7}{t8}</li>;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  return t9;
}
function _temp(item) {
  return item.status === "failed" && !item.retryDisabledReason;
}